<template>

    <div class="content-wrap">
       <div>
      <div class="mb-3 d-flex align-items-center justify-content-end">
        <ElLabel name="사업자/개인 구분" classNm="me-2 btn-s-tb">
          <template #end="{id}">
            <div class="radio-btn-toggle d-flex">
              <ElLabel name="사업자" classNm="btn btn-sm flex-fill">
                <template #start="{id}">
                  <ElRadio
                    :id="id"
                    classNm="btn-check"
                    :value="'1'"
                    v-model="state.companyParams.account_type"
                  />
                </template>
              </ElLabel>
              <ElLabel name="개인" classNm="btn btn-sm flex-fill">
                <template #start="{id}">
                  <ElRadio
                    :id="id"
                    classNm="btn-check"
                    v-model="state.companyParams.account_type"
                    :value="'2'"
                  />
                </template>
              </ElLabel>
            </div>
          </template>
        </ElLabel>
      </div>
    </div>
      <div class="register-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="관리번호">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.companyParams.cmp_info_seq" :disabled='true'/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
                <ElLabel name="회사" :required="checkRequired('cmp_nm')">
                  <template #end="{id}" >
                    <ElInput :id="id" ref="cmpNmRef" v-model="state.tmpVal.cmp_nm"  @update:modelValue="checkChange()" :maxlength='100'/>
                  </template>
                </ElLabel>
            </div>
            <div class="col-md-6">
              <ElLabel name="사업부명" >
                  <template #end="{id}">
                    <div class="input-group">
                      <ElInput :id="id" ref="cmpDvsnNmRef" v-model="state.tmpVal.cmp_dvsn_nm" :maxlength='100'  @update:modelValue="checkChange()"/>
                      <ElButton
                        type="btn-s-tb"
                        ref="dupBtnRef"
                        @buttonClick="checkDup()"
                      >
                        중복확인
                      </ElButton>
                    </div>

                  </template>
              </ElLabel>
            </div>
          </div>
        </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="사업자 등록 번호" :required="checkRequired('business_no')">
                <template #end="{id}">
                  <ElInput :id="id" ref="businessNoRef" v-model="state.companyParams.business_no" :maxlength='12' @update:modelValue="bizNoFormat"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="전화번호">
                  <template #end="{id}">
                    <ElInput :id="id" ref="telNoRef" v-model="state.companyParams.tel_no" @update:modelValue="getTeleMask" :maxlength="12" />
                  </template>
                </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="대표자" :required="checkRequired('ceo_nm')">
                <template #end="{id}">
                  <ElInput :id="id" ref="ceoRef" v-model="state.companyParams.ceo_nm" :maxlength="10"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
                <ElLabel name="팩스번호">
                  <template #end="{id}">
                    <ElInput :id="id" ref="faxRef" v-model="state.companyParams.fax_no" :maxlength="13" @update:modelValue="getFaxMask"/>
                  </template>
                </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="홈페이지">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.companyParams.homepage" :maxlength="100"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
              <ElLabel name="주소" :required="checkRequired('address')">
                <template #end="{id}">
                  <div class="input-group mb-3" @click="openModal('address')">
                    <ElInput :id="id" ref="addressRef" v-model="state.companyParams.address" :readonly='true' :maxlength="255"/>
                    <ElButton
                      type="btn-s-tb"
                    >
                      주소검색
                    </ElButton>
                  </div>
                </template>
              </ElLabel>
              <Address ref="addressModalRef" @em_address="getAddr" />
  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3">
  
              <ElLabel name="상세주소" :required="checkRequired('address_dtl')">
                <template #end="{id}">
                  <ElInput :id="id" ref="addressDtlRef" v-model="state.companyParams.address_dtl" :maxlength="255"/>
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
  
              <ElLabel name="업태/업종">
                <template #end="{id}">
                  <ElInput :id="id" ref="sectRef" v-model="state.companyParams.sector" :maxlength="100"/>
                </template>
              </ElLabel>
  
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="업데이트 날짜">
                <template #end="{id}">
                  <DatePicker 
                  :id="id" 
                  v-model="state.companyParams.fmt_upd_dt"
                  disabled
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="담당자 등록" >
                <template #end="{id}">
                  <div class="input-group">
                    <ElInput :id="id" v-model="state.companyParams.mngr_nm" @inputClick="openModal('managerReg')" readonly/>
                    <ElButton
                      type="btn-s-tb"
                      @buttonClick="openModal('managerReg')"
                    >
                      담당자 등록
                    </ElButton>
                  </div>
                </template>
              </ElLabel>
  
                <ManagerRegModal
                  ref="managerRegModalRef"
                  call-page="cp"
                  :mng_seq="state.companyParams.mng_seq"
                  @return="
                    (r) => (  getMngData(r))
                  "
                />
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="이메일" :required="checkRequired('email')">
                <template #end="{id}">
                  <ElInput :id="id" ref="emailRef" v-model="state.companyParams.email" :maxlength="50"/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row band">
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="Activity(Marketing inform)">
                <template #end="{id}">
                  <ElTextarea 
                    v-model="state.companyParams.activity"
                    :id="id"
                    :rows="3"
                  />
                </template>
              </ElLabel>
              
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="메모">
                <template #end="{id}">
                  <ElTextarea 
                    v-model="state.companyParams.note"
                    :id="id"
                    :rows="3"
                  />
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row band">
          <div class="col-md-3">
            <div class="mb-3">
  
              <ElLabel name="활성화/비활성화">
                <template #end="{id}">
                  <div class="radio-btn-toggle d-flex">
                    <ElLabel name="활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                          :id="id"
                          classNm="btn-check"
                          :value="true"
                          v-model="state.companyParams.enable_yn"
                        />
                      </template>
                    </ElLabel>
  
  
                    <ElLabel name="비활성화" classNm="btn btn-sm flex-fill">
                      <template #start="{id}">
                        <ElRadio
                          :id="id"
                          classNm="btn-check"
                          v-model="state.companyParams.enable_yn"
                          :value="false"
                        />
                      </template>
                    </ElLabel>
                  </div>
                  
                </template>
              </ElLabel>
  
              
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="즐겨찾기">
                <template #end="{id}">
                  <ElButton
                    :id="id"
                    type="bookmarkL"
                    :active="state.companyParams.bkmark_yn == 'Y'"
                    @buttonClick="state.companyParams.bkmark_yn == 'Y' ? changeVal('bkmark_yn', 'N') : changeVal('bkmark_yn', 'Y')"
                  >
                    즐겨찾기 추가
                  </ElButton>
                </template>
              </ElLabel>
              
            </div>
          </div>
        </div>
        <!--todo : captionList 공통컴포넌트 적용-->
        <div class="row">
          <Caption
            ref="captionRef"
            :tbId="'cmp'"
            :cap_seq="state.companyParams.cp_seq"
          />
        </div>
      </div>
      <!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="router.back()">이전</ElButton>
        <!-- <ElButton type="primary" @buttonClick="checkValidation('Y')">
          임시저장
        </ElButton>
        <ElButton
          type="primary"
          @buttonClick="clickTmpSaveGo()"
        >
          임시저장함
        </ElButton> -->
  
  
        <ElButton
          type="primary"
          @buttonClick="checkValidation('N')"
        >
          수정완료
        </ElButton>
      </div>
  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton
              type="accordionHeader"
              target="panelsStayOpen-collapseOne"
            >
              첨부파일
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              <!-- <table>
                <tr></tr>
              </table> -->
              <FileUpload ref="fileUploadRef" @return="(res) => getFileList(res)"
                @deleteData="(res) => getDeleteFile(res)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
    <!-- <ExcelUploadModal ref="excelUploadModalRef" :colDefs="state.excelModalColDefs" @return="saveAll" /> -->
</template>
  
<script setup>
import { reactive, ref, onBeforeMount, computed } from "vue";
// import ExcelUploadModal from "@/components/common/modal/ExcelUploadModal.vue";
import Address from "@/components/common/modal/AddressModal.vue";
import Caption from '@/components/common/CaptionList.vue';
import ManagerRegModal from "@/components/common/modal/ManagerRegModal.vue";

import { useRouter } from "vue-router";

import DatePicker from "@/components/common/DatePicker.vue";
import FileUpload from "@/components/common/FileUpload.vue";
import routerCmn from "@/js/vueRouterCmn";
import common from "@/js/common";
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { compSelect, compInfoNextSeq } from "@/api/comp";
import { fileList } from "@/api/file";
import { compEdit, compCheck } from "@/api/comp";

const router = useRouter();

const fileUploadRef = ref();
const dupBtnRef = ref();

const cmpNmRef = ref();
const cmpDvsnNmRef = ref();
const businessNoRef = ref();
const telNoRef = ref()
const ceoRef = ref();
const faxRef = ref()
const sectRef = ref();
const addressRef = ref();
const addressDtlRef = ref();
const emailRef = ref();

const managerRegModalRef = ref();
const addressModalRef = ref();
const excelUploadModalRef = ref();
const captionRef = ref();


onBeforeMount(async () => {
  let cp_seq = history.state.cp_seq;
  if(cp_seq){
    searchCmpDtl(cp_seq)
  }else{
    alert('잘못된 접근입니다.')
    router.back()
  }
});

const bizRequired = ['cmp_nm','business_no','address','address_dtl','ceo_nm']
const personRequired = ['cmp_nm','email','ceo_nm']


const checkRequired =(name)=>{
  if(state.companyParams.account_type === '1'){
    return bizRequired.includes(name)
  }else{
    return personRequired.includes(name)
  }
}


async function searchCmpDtl(cp_seq){
  let param = {
    cp_seq: cp_seq,
  };
  try {
    setIsLoading(true)
    const res = await compSelect(param)
    if(Object.keys(res.rtn).length === 0){
      alert('조회되는 회사가 없습니다.확인 후 다시 조회해주세요')
      router.push('/cp/MCP_CR_002')
      return
    }
    let detailCp = res.rtn;
    state.companyParams.note = detailCp.note;
    state.companyParams.activity = detailCp.activity;
    state.companyParams.cmp_seq = detailCp.cmp_seq;
    state.companyParams.enable_yn = detailCp.enable_yn;

    if (state.companyParams.enable_yn == "Y") {
      state.companyParams.enable_yn = true;
    } else {
      state.companyParams.enable_yn = false;
    }

    state.companyParams.bkmark_yn = detailCp.bkmark_yn;
    state.companyParams.cp_seq = detailCp.cp_seq;
    state.companyParams.ceo_nm = detailCp.ceo_nm;
    state.companyParams.mng_seq = detailCp.mng_seq;
    state.companyParams.cap_seq =
      detailCp.cap_seq == "" ? 0 : detailCp.cap_seq;
    state.companyParams.tel_no = detailCp.tel_no;
    state.companyParams.cmp_info_seq = detailCp.cmp_info_seq;
    state.companyParams.sector = detailCp.sector;

    state.companyParams.sr = detailCp.sr;
    state.companyParams.map_ck = detailCp.map_ck;

    state.tmpVal.cmp_dvsn_nm = detailCp.cmp_dvsn_nm;
    state.tmpVal.cmp_nm = detailCp.cmp_nm;

    state.companyParams.cmp_nm = detailCp.cmp_nm;
    state.companyParams.cmp_dvsn_nm = detailCp.cmp_dvsn_nm;

    state.originVal.cmp_nm = detailCp.cmp_nm;
    state.originVal.cmp_dvsn_nm = detailCp.cmp_dvsn_nm;

    state.companyParams.business_no = detailCp.business_no;
    state.companyParams.am = detailCp.am;
    state.companyParams.end_yn = detailCp.end_yn;
    state.companyParams.address = detailCp.address;
    state.companyParams.address_dtl = detailCp.address_dtl;

    state.companyParams.fax_no = detailCp.fax_no;
    state.companyParams.homepage = detailCp.homepage;
    state.companyParams.fmt_upd_dt = detailCp.fmt_upd_dt;
    state.companyParams.account_type = detailCp.account_type;
    state.companyParams.email = detailCp.email;

    state.dupCheck = true;

    //첨부파일이 존재할경우 파일리스트 조회api 호출
    if (
      detailCp.file_seq_grp != "" &&
      detailCp.file_seq_grp != null &&
      detailCp.file_seq_grp != undefined
    ) {
      let apiParam = {
        file_seq_grp: detailCp.file_seq_grp,
      };
      try {
        const resFileList = await fileList(apiParam)
        fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn;
      } catch (err) {
        console.log("파일리스트 조회 api 에러", err);
        alert("파일리스트 조회에 실패했습니다.");
        // routerCmn.routerPush("/cp/MCP_CR_002");
        throw err
      }
    }
  } catch (err) {
    console.log("회사 상세조회 api 에러", err);
    alert("회사 상세 조회에 실패했습니다.");
    routerCmn.routerPush("/cp/MCP_CR_002");
  } finally {
    setIsLoading(false)
  }
}
const changeVal = (key, val) => {
  state.companyParams[key] = val;
};

const state = reactive({
  companyParams: {
    cp_seq: "",
    cmp_nm: "",
    cmp_dvsn_nm: "",
    mngr_nm :"",
    note: "",
    activity: "",
    cmp_seq: 5,
    // enable: true,
    enable_yn: true,
    bkmark_yn: "N",
    ceo_nm: "",
    mng_seq: null,
    cap_seq: 5,
    tb_id: "cmp",
    tel_no: "",
    cmp_info_seq: "",
    sector: "",
    sr: "",
    map_ck: "N",
    business_no: "",
    am: "",
    end_yn: "",
    tmp_yn: 'N',
    address: "",
    address_dtl: "",
    fax_no: "",
    homepage: "",
    upt_dt: "",
    email:"",
    account_type:'1',
    attachFileVO: {
      file_div_id: "10",
      file_seq: "", //추가 된 파일 seq 전송
      del_file_seq: "", // 삭제해야 할 파일 seq 전송
    },
  },
  managerNm: "",
  dupCheck: false,
  dupCheck2 : false,
  tmpVal: {
    cmp_nm: "",
    cmp_dvsn_nm: "",
  },
  //파일 첨부 데이터()
  fileList: [],
  delFileList: [],
  originVal: {
    cmp_nm: "",
    cmp_dvsn_nm: "",
  },
  excelModalColDefs: [
    { header: "회사명", field: "cmp_nm", style: { minWidth: '100px' } },
    { header: "사업부명", field: "cmp_dvsn_nm", style: { minWidth: '100px' } },
    { header: "사업자등록번호", field: "business_no", type: 'businessNo', style: { minWidth: '100px' } },
    { header: "전화번호", field: "tel_no", type: 'tel', type: 'telPhone', style: { minWidth: '100px' } },
    { header: "대표자", field: "ceo", style: { minWidth: '100px' } },
    { header: "팩스번호", field: "fax_no", type: 'tel', style: { minWidth: '100px' } },
    { header: "홈페이지", field: "homepage", style: { minWidth: '100px' } },
    { header: "주소", field: "address", style: { minWidth: '100px' } },
    { header: "상세주소", field: "address_dtl", style: { minWidth: '100px' } },
    { header: "업테/업종", field: "sector", style: { minWidth: '100px' } },
    { header: "담당자", field: "mngr_nm", style: { minWidth: '100px' } },
    { header: "note", field: "note", style: { minWidth: '100px' } },
  ],
});

const getMngData = (data) => {
  state.companyParams.mng_seq = data.mng_seq;
  state.companyParams.mngr_nm = data.mngr_nm;

};

//유선전화 형식 (지역번호별 분기)
const getTeleMask = (tel_no) => {
  tel_no = common.checkOnlyNumber(tel_no)
  if (tel_no.indexOf("02") == 0) {
    state.companyParams.tel_no = common.teleFormat02(tel_no)
    telNoRef.value.input.value = common.teleFormat02(tel_no)

  } else {
    state.companyParams.tel_no = common.teleFormat(tel_no)
    telNoRef.value.input.value = common.teleFormat02(tel_no)
  }
}

//팩스번호 형식 (지역번호별 분기)
const getFaxMask = (fax_no) => {
  if (fax_no.indexOf("02") == 0) {
    state.companyParams.fax_no = common.teleFormat02(fax_no);
    faxRef.value.input.value = common.teleFormat02(fax_no)
  } else {
    state.companyParams.fax_no = common.teleFormat(fax_no);
    faxRef.value.input.value = common.teleFormat(fax_no)
  }
};

//사업자번호 형식 체크
const bizNoFormat = (no) => {
  no = common.checkOnlyNumber(no)
  state.companyParams.business_no = common.bizNoFormat(no);
  businessNoRef.value.input.value = common.bizNoFormat(no);
};

//이메일 형식
const getEmailMark = (data) => {
  if(!common.checkEmail(data)){
    alert("이메일 형식을 확인해주세요")
    return false
  }else{
    state.companyParams.email
  }
};

//특수문자
const getNameMask = () => {

  let msg = '특수문자는 입력할 수 없습니다.'

  if (common.checkSpecChar2(state.companyParams.sector)) {
    alert(msg)
    sectRef.value.input.focus()
    return false
  }

  state.companyParams.cmp_nm = state.tmpVal.cmp_nm;

  return true


  // state.tmpVal.cmp_dvsn_nm = common.checkSpecChar(state.tmpVal.cmp_dvsn_nm);
  // state.companyParams.ceo_nm = common.checkSpecChar(state.companyParams.ceo_nm);
  // state.companyParams.address_dtl = common.checkSpecChar(state.companyParams.address_dtl);
  // state.companyParams.sector = common.checkSpecChar(state.companyParams.sector);
};


//첨부파일 및 저장 상태값 확인
const  checkValidation = async (status) => {

  let msg = codeStore.getCodeMsg("77777"); // 해당 항목은 필수 입력값입니다.


  //임시저장 아닐때 필수값 모두 체크
  if(status === 'N' && state.companyParams.enable_yn === true){
    if (!state.tmpVal.cmp_nm) {
      //회사명
      alert(msg);
      cmpNmRef.value.input.focus();
      return;
    }

    if (state.dupCheck == false) {
      if(state.dupCheck2 === 1){
        alert('회사명이 변경되었습니다 중복확인을 다시 해주세요.')
        return;
      }else if(state.dupCheck2 === 2){
        alert('사업부명이 변경되었습니다. 중복확인을 다시 해주세요.')
        return;
      }else{
        alert("중복확인을 진행해주세요.");
        return;
      }
     
    }

    if(state.companyParams.account_type === '1'){
      if (
        !state.companyParams.business_no ||
        state.companyParams.business_no.trim() == 0
      ) {
        //사업자등록번호
        alert(msg);
        businessNoRef.value.input.focus();
        return;
      }


      if (!state.companyParams.ceo_nm) {
        alert(msg);
        ceoRef.value.input.focus();
        return;
      }

      if (!state.companyParams.address) {
        alert(msg);
        addressRef.value.input.focus();
        return;
      }

      if (!state.companyParams.address_dtl) {
        alert(msg);
        addressDtlRef.value.input.focus();
        return;
      }

    }else{
      if (!state.companyParams.ceo_nm) {
        alert(msg);
        ceoRef.value.input.focus();
        return;
      }

      if (state.companyParams.email.trim() == "") {
        //이메일
        alert(msg);
        emailRef.value.input.focus();
        return
      }
      
      if(getEmailMark(state.companyParams.email.trim()) == false){
        emailRef.value.input.focus();
        return 
      }
    }
  }

  //if (!getNameMask())return 2024-11-29 삭제요청 업태/업종 특수문자(,) 필요

  //임시저장 및 저장 상태값
  state.companyParams.tmp_yn = status;


  if(!confirm('저장하시겠습니까?')) return

  regCompany();


};


//업로드 파일 저장 후 실행되는 함수
const getFileList = (res) => {
  if (res && res?.length > 0) {
    state.fileList = []
    res.map((file) => {
      state.fileList.push(file.file_seq);
    });

    regCompany();
  } else {
    router.push('/cp/MCP_CR_002')
    alert("파일 업로드에 실패했습니다.다시 시도해주세요.");
  }
};

const regCompany = async () => {

  //파일 첨부 데이터가 있는지 확인
  let tmpFiles = fileUploadRef.value.state.tmpFileList
  if (tmpFiles.length > 0) {
    //임시파일이 있으면 실제 경로 저장
    await fileUploadRef.value.uploadFile("company/file")
    return
  }

  //활성화 비활성화 값
  state.companyParams.enable_yn = state.companyParams.enable_yn ? "Y" : "N";


  if (state.fileList.length > 0) {
    state.companyParams.attachFileVO.file_seq = state.fileList.toString();
  }

  if (state.delFileList.length > 0) {
    state.companyParams.attachFileVO.del_file_seq = state.delFileList.toString();
  }

  try {
    setIsLoading(true)
    const res = await compEdit(state.companyParams)
    if(res.rtn.cp_seq){
      const capRes = await captionRef.value.saveCapCtnt(res.rtn.cp_seq)
      if(capRes.code === '0000'){
        
        if(state.companyParams.tmp_yn === 'Y'){
          const is = confirm("수정 완료했습니다. 어카운트 매핑 화면으로 이동하시겠습니까?")
          if(is){
            router.push('/cf/MCF_SC_004')
          }else{
            router.push('/cp/MCP_CR_002')
          }
        }else{
          const is = confirm("수정 완료했습니다. 어카운트 매핑 화면으로 이동하시겠습니까?")
          if(is){
            router.push('/cf/MCF_SC_004')
          }else{
            router.push('/cp/MCP_CR_002')
          }
        }
        return
      }
    }
    throw new Error()
  } catch (err) {
    console.error(err)
    alert("수정 실패했습니다.")
  } finally {
    setIsLoading(false)
  }
};

const checkDup = async () => {
  if (!state.tmpVal.cmp_nm) {
    alert("회사명을 입력해주세요");
    return;
  }

  let params = {};

  //수정화면일 경우
  if (
    state.tmpVal.cmp_nm.trim() == state.companyParams.cmp_nm.trim() &&
    state.tmpVal.cmp_dvsn_nm.trim() == state.companyParams.cmp_dvsn_nm.trim()
  ) {
    state.dupCheck = true;
    alert("기존 회사명&사업부명과 동일합니다.");
    return;
  }

  if (
    state.tmpVal.cmp_nm.trim() == state.originVal.cmp_nm.trim() &&
    state.tmpVal.cmp_dvsn_nm.trim() == state.originVal.cmp_dvsn_nm.trim()
  ) {
    state.dupCheck = true;
    alert("기존 회사명&사업부명과 동일합니다.");
    return;
  }

  params = {
    cmp_nm: state.tmpVal.cmp_nm,
    cmp_dvsn_nm: state.tmpVal.cmp_dvsn_nm,
  };

  try {
    const res = await compCheck(params)

    if (res.rtn.cp_seq) {
      state.dupCheck = false;
      let msg = codeStore.getCodeMsg("00002");
      alert(msg);
    } else {
      state.dupCheck = true;
      state.companyParams.cmp_nm = state.tmpVal.cmp_nm;
      state.companyParams.cmp_dvsn_nm = state.tmpVal.cmp_dvsn_nm;
      alert("사용 가능한 회사명 & 사업부명입니다.");
    }
  } catch (err) {
    console.error(err)
  }
};

const btnDisabled = computed(()=>{
 //수정화면일 경우
 if (
    state.tmpVal.cmp_nm.trim() == state.companyParams.cmp_nm.trim() &&
    state.tmpVal.cmp_dvsn_nm.trim() == state.companyParams.cmp_dvsn_nm.trim()
  ) {
    state.dupCheck = true;
    // dupBtnRef.value.button.disabled = true;
    // alert("기존 회사명&사업부명과 동일합니다.");
    return  true
  }

  if (
    state.tmpVal.cmp_nm.trim() == state.originVal.cmp_nm.trim() &&
    state.tmpVal.cmp_dvsn_nm.trim() == state.originVal.cmp_dvsn_nm.trim()
  ) {
    state.dupCheck = true;
    dupBtnRef.value.button.disabled = true;
    // alert("기존 회사명&사업부명과 동일합니다.");
    return true
  }
})

   
const checkChange = () => {
  if(state.dupCheck){
    if (state.companyParams.cmp_nm != state.tmpVal.cmp_nm) {
      state.dupCheck = false;
      state.dupCheck2 = 1;
      return
    } else {
      state.dupCheck = true;
    }
    if (state.companyParams.cmp_dvsn_nm != state.tmpVal.cmp_dvsn_nm) {
      state.dupCheck = false;
      state.dupCheck2 = 2;
      return
    } else {
      state.dupCheck = true;
    }
  }
};

const getAddr = (addr) => {
  state.companyParams.address = addr.address;
};


const openModal = (modal) => {
  if (modal === "managerReg") {
    managerRegModalRef.value.openModal();
  } else if (modal === "upload") {
    excelUploadModalRef.value.openModal();
  } else if (modal === "address") {
    addressModalRef.value.openModal();
  }
};


const getDeleteFile = (res) => {
  state.delFileList.push(res.file_seq);
};



let checkKeyNm = [
  'business_no'
  ,'tel_no'
  ,'ceo_nm'
  ,'fax_no'
  ,'homepage'
  ,'address'
  ,'address_dtl',
  ,'sector'
  ,'fmt_upd_dt'
  ,'mngr_nm'
  ,'mng_seq'
  ,'activity'
  ,'note'
]
function clickTmpSaveGo(){
  let checkFlag = false  

  checkFlag = checkKeyNm.some((key)=>{
    if(key !== 'bkmark_yn' && state.companyParams[key]) return true
    return false
  })

  if(!checkFlag && (state.tmpVal.cmp_dvsn_nm || state.tmpVal.cmp_nm)) checkFlag = true

  if(checkFlag){
    if(!confirm('임시저장후 이동바랍니다. 이 페이지에서 나가시겠습니까?'))return
  }
    
  router.push('/mp/MMP_AM_001')

}
</script>
  